import type {CoreOrB2b} from './types';

export const isCoreOrB2b = <C, B>(
  value: CoreOrB2b<C, B>,
): value is CoreOrB2b<C, B> => Boolean(value.core || value.b2b);
